import { useSelector } from 'react-redux';
import CCLFDeveloperApplication from '@/components/Rover/DeveloperApplications/CCLFDevelopersIntake/CCLFDeveloperApplication';
import EquityInActionApplication from '@/components/Rover/DeveloperApplications/EquityInAction/EquityInActionApplication';
import Unauthorized from '@/components/Unauthorized';
import { ClientAccount } from '../../../../constants/DeveloperApplication';
import useEnvironment from '../../../../hooks/useEnvironment';
import { authSelector } from '../../../../store';

const ClientApplication = () => {
  const { data: currentUserData } = useSelector(authSelector);
  const { account } = currentUserData;
  const { isDev } = useEnvironment();

  switch (account.toUpperCase()) {
    case ClientAccount.CHICAGOREBUILD:
      return <CCLFDeveloperApplication />;
    case ClientAccount.EQUITYINACTION:
      return <EquityInActionApplication />;
    default:
      if (isDev) {
        return <CCLFDeveloperApplication />;
      }
      return <Unauthorized />;
  }
};
export default ClientApplication;
